import { getCorrectOffSalesRegion } from "../../shared/util";

export default (entity) => {
  if (entity.siteOptions.footerAboutCustomText) {
    return entity.siteOptions.footerAboutCustomText;
  }
  if (entity.siteOptions.entityType === 2) {
    return `${entity.displayName} members are skilled
      professionals with insightful local knowledge and extensive expertise in ${getCorrectOffSalesRegion(
        entity
      )} 
      luxury real estate. The team's dedication to high-quality service,
      combined with the one-of-a-kind resources, reputation, and access to discerning
      clients that the global brand provides, are powerful advantages that can help
      you successfully navigate the ${getCorrectOffSalesRegion(
        entity
      )} real estate market.`;
  } else {
    return `${entity.displayName}, a ${entity.brand} agent, is a skilled
      professional with insightful local knowledge and extensive expertise in ${getCorrectOffSalesRegion(
        entity
      )} 
      luxury real estate. ${
        entity.preferredFirstName || entity.firstName
      }'s dedication to high-quality service,
      combined with the one-of-a-kind resources, reputation, and access to discerning
      clients that the global brand provides, are powerful advantages that can help
      you successfully navigate the ${getCorrectOffSalesRegion(
        entity
      )} real estate market.`;
  }
};



// WEBPACK FOOTER //
// ./src/components/shared/footer/about.js